module.exports = __webpack_public_path__ + "media/bootstrap-icons/battery-charging-bb414431.svg";